import standardDeutsch from './st-standard-deutsch.json';
import standardEnglish from './st-standard-english.json';
import { Podt } from '../../types';

export default [
  standardDeutsch.data.getPodtTest as Podt,
  standardEnglish.data.getPodtTest as Podt,
];
